import firebase from 'firebase';
import 'firebase/firestore';
import 'firebase/performance';
import { firebaseConfig } from './config';

// Get a Firestore instance
export const firebaseApp = firebase.initializeApp(firebaseConfig);
export const db = firebaseApp.firestore();
